import * as XLSX from 'xlsx';

export const exportToExcel = (data, filename, sheetName = 'Sheet1') => {
  
  const wb = XLSX.utils.book_new();
  
  const ws = XLSX.utils.json_to_sheet(data);
  
  if (data.length > 0) {
    const colWidths = Object.keys(data[0]).map(key => {
      const maxLength = Math.max(
        key.length,
        ...data.map(row => String(row[key] || '').length)
      );
      return { wch: Math.min(maxLength + 2, 50) };
    });
    ws['!cols'] = colWidths;
  }
  
  
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  
 
  XLSX.writeFile(wb, `${filename}_${new Date().toISOString().split('T')[0]}.xlsx`);
};

export const exportOrdersToExcel = (orders) => {
  const getStatusLabel = (status) => {
    const labels = {
      'siparis_alindi': 'Sipariş Alındı',
      'uretimde': 'Üretimde',
      'teslim_edildi': 'Teslim Edildi'
    };
    return labels[status] || status;
  };

  const formattedData = orders.map(order => ({
    'ID': order.id,
    'Müşteri Adı': order.customer_name || '-',
    'Telefon': order.customer_phone || '-',
    'İş Tipi': order.job_type || '-',
    'Durum': getStatusLabel(order.status),
    'Fatura': order.invoice_included ? 'Evet' : 'Hayır',
    'Toplam Fiyat': order.total_price ? Number(order.total_price).toFixed(2) : 0,
    'Ödenen': order.total_paid ? Number(order.total_paid).toFixed(2) : 0,
    'Kalan': order.remaining_balance ? Number(order.remaining_balance).toFixed(2) : 0,
    'Sipariş Tarihi': order.order_date ? new Date(order.order_date).toLocaleDateString('tr-TR') : '-',
    'Teslim Tarihi': order.delivery_date ? new Date(order.delivery_date).toLocaleDateString('tr-TR') : '-',
    'Siparişi Alan': order.representative || '-',
    'Açıklama': order.description || '-'
  }));
  
  exportToExcel(formattedData, 'Siparisler', 'Siparişler');
};

export const exportCustomersToExcel = (customers) => {
  const formattedData = customers.map(customer => ({
    'ID': customer.id,
    'Ad Soyad': customer.name,
    'Telefon': customer.phone || '-',
    'Email': customer.email || '-',
    'Adres': customer.address || '-',
    'Vergi No': customer.tax_number || '-',
    'Vergi Dairesi': customer.tax_office || '-',
    'Notlar': customer.notes || '-'
  }));
  
  exportToExcel(formattedData, 'Musteriler', 'Müşteriler');
};

export const exportEmployeesToExcel = (employees) => {
  const getPaymentTypeLabel = (type) => {
    const labels = {
      'monthly': 'Aylık',
      'daily': 'Günlük',
      'hourly': 'Saatlik'
    };
    return labels[type] || type;
  };

  const formattedData = employees.map(employee => ({
    'ID': employee.id,
    'Ad Soyad': employee.full_name,
    'TC No': employee.tc_no || '-',
    'Telefon': employee.phone || '-',
    'Email': employee.email || '-',
    'Pozisyon': employee.position || '-',
    'Departman': employee.department || '-',
    'İşe Giriş': employee.hire_date ? new Date(employee.hire_date).toLocaleDateString('tr-TR') : '-',
    'İşten Çıkış': employee.termination_date || '-',
    'Durum': employee.is_active ? 'Aktif' : 'Pasif',
    'Sigorta': employee.is_insured ? 'Sigortalı' : 'Sigortasız',
    'Sigorta Başlangıç': employee.insurance_start_date || '-',
    'Maaş': employee.salary || '-',
    'Ödeme Tipi': getPaymentTypeLabel(employee.payment_type),
    'Yıllık İzin': employee.annual_leave_days || 14,
    'Notlar': employee.notes || '-'
  }));
  
  exportToExcel(formattedData, 'Calisanlar', 'Çalışanlar');
};

// Araçlar için export
export const exportVehiclesToExcel = (vehicles) => {
  const formattedData = vehicles.map(vehicle => ({
    'ID': vehicle.id,
    'Plaka': vehicle.plate,
    'Marka': vehicle.brand || '-',
    'Model': vehicle.model || '-',
    'Yıl': vehicle.year || '-',
    'Mevcut KM': vehicle.current_km ? vehicle.current_km.toLocaleString('tr-TR') : '-',
    'Durum': vehicle.is_active ? 'Aktif' : 'Pasif',
    'Sigorta Başlangıç': vehicle.insurance_start || '-',
    'Sigorta Bitiş': vehicle.insurance_end || '-',
    'Sigorta Şirketi': vehicle.insurance_company || '-',
    'Kasko Başlangıç': vehicle.kasko_start || '-',
    'Kasko Bitiş': vehicle.kasko_end || '-',
    'Kasko Şirketi': vehicle.kasko_company || '-',
    'Muayene Başlangıç': vehicle.inspection_start || '-',
    'Muayene Bitiş': vehicle.inspection_end || '-',
    'Notlar': vehicle.notes || '-'
  }));
  
  exportToExcel(formattedData, 'Araclar', 'Araçlar');
};